import React from "react";

export default function PromoTwo() {
  return (
    <>
      <section className="promo-section ptb-50">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-10">
              <div className="section-heading mb-5">
                <span className="text-uppercase color-secondary sub-title">
                 Ayuda
                </span>
                <h2 className="mb-6">
                 Preguntas por tipo de Usuario
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-6 mb-lg-0">
              <a href="/usuarios">
              <div className="card single-promo-card single-promo-hover">
                <div className="card-body">
                  <div className="pb-2">
                    <span className="ti-unlock icon-md color-secondary"></span>
                  </div>
                  <div className="pt-2 pb-3">
                    <h5>Usuario</h5>
                    <p className="text-muted mb-0">
                      Conoce como suscribirte a un perfil, comprar y ver tus packs, agregar creadores a tu lista de deseos. 
                    </p>
                  </div>
                </div>
              </div>
              </a>
            </div>
            <div className="col-lg-3 col-sm-6">
            <a href="/creadores">
              <div className="card single-promo-card single-promo-hover mb-lg-0">
                <div className="card-body">
                  <div className="pb-2">
                    <span className="ti-video-clapper icon-md color-secondary"></span>
                  </div>
                  <div className="pt-2 pb-3">
                    <h5>Creadores</h5>
                    <p className="text-muted mb-0">
                      Aprende a crear contenido, retirar el dinero generado, promocionar tu cuenta y mas.
                    </p>
                  </div>
                </div>
              </div>
              </a>
            </div>
            <div className="col-lg-3 col-sm-6">
            {/* <a href="/agencias">
              <div className="card single-promo-card single-promo-hover mb-lg-0">
                <div className="card-body">
                  <div className="pb-2">
                    <span className="ti-vector icon-md color-secondary"></span>
                  </div>
                  <div className="pt-2 pb-3">
                    <h5>Agencia y Productoras</h5>
                    <p className="text-muted mb-0">
                      Tenemos una funcionalidad exclusiva de Acuerdos comerciales , aprende a hacer acuerdos con tus modelos y comisiona por ser parte de tu agencia sobre sus ventas. 
                    </p>
                  </div>
                </div>
              </div>
            </a> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
